/*
* returns string with current date and time in a sensible format
*
*/
export function getCurrentDateAndTime() {
  
  let now = new Date();
  let month = now.toLocaleDateString('default', {month: 'short'})
  let date = now.getDate();
  let year = now.getFullYear();
  let hours = now.getHours();
  let minutes = now.getMinutes();
  let seconds = now.getSeconds();

  return `${date} ${month} ${year} ${hours}:${minutes}:${seconds}`;
 
}

export function formatCurrency(price, currencyCode = 'USD') {

  const formatter = new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: currencyCode,
    minimumFractionDigits: 2,
    maximumFractionDigits: 2
  });

   return formatter.format(price / 100);

}

function nth(day) {
  if (day > 3 && day < 21) {
    return `${day}th`;
  }
  switch (day % 10) {
    case 1: return `${day}st`;
    case 2: return `${day}nd`;
    case 3: return `${day}rd`;
    default: return `${day}th`;
  }
}

export function formatDate(rawDate, locale) {
  const date = new Date(rawDate);
  const year = new Intl.DateTimeFormat('en', {year: 'numeric'}).format(date);
  const month = new Intl.DateTimeFormat('en', {month: 'long'}).format(date);
  const day = new Intl.DateTimeFormat('en', {day: 'numeric'}).format(date);
  if (locale == "UK") {
    return `${nth(day)} ${month} ${year}`;
  } else {
    return `${month} ${nth(day)} ${year}`;
  }
}

export function objectToFormData(obj) {
  const formData = new FormData();

  Object.entries(obj).forEach(([key, value]) => {
    formData.append(key, value);
  });

  return formData;
}